var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('response-nav-widget',{attrs:{"header-nav-data":_vm.mainNavData}}),_vm._v(" "),_c('section',{staticClass:"pad-t-7 mrg-b-10 pad-h-3 mrg-b-7-s"},[_c('img',{attrs:{"src":require(("@/assets/img/daas_case/" + _vm.packageId + "_title.png"))}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7669c526","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sec-header-widget.vue
// module id = null
// module chunks = 